module.exports = __webpack_public_path__ + "6cab49f8ff.woff2";